import type {SharedBulkActionsItemPickerProps} from '@github-ui/item-picker-base/ItemPicker'
import type {MilestonePickerBaseProps} from '@github-ui/item-picker-milestone'
import {
  BulkIssueMilestonePicker as BulkIssueMilestonePickerTsq,
  type BulkIssueMilestonePickerProps as BulkIssueMilestonePickerTsqProps,
} from '@github-ui/item-picker-milestone-tsq/BulkIssueMilestonePicker'
import {useCallback} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {addMilestoneToStore, updateIssuesById} from '../relay-tsq-interop'

export type MilestonePickerProps = Omit<
  MilestonePickerBaseProps,
  'repositoryId' | 'setIsLoading' | 'milestones' | 'onCreate' | 'fetchMilestones'
> & {
  repo: string
  owner: string
}

export type BulkIssueMilestonePickerProps = Omit<
  MilestonePickerProps,
  'issueId' | 'onIssueUpdate' | 'onSelectionChange'
> &
  SharedBulkActionsItemPickerProps

export function BulkIssueMilestonePicker(props: BulkIssueMilestonePickerProps) {
  const environment = useRelayEnvironment()
  const onMutate: BulkIssueMilestonePickerTsqProps['onMutate'] = useCallback(
    input => {
      environment.commitUpdate(store => {
        const {ids, ...updateArgs} = input
        if ('milestoneId' in updateArgs && updateArgs.milestone) {
          addMilestoneToStore(store, updateArgs.milestoneId, updateArgs.milestone)
        }
        updateIssuesById(store, ids, {
          clearMilestone: 'clearMilestone' in updateArgs ? updateArgs.clearMilestone : undefined,
          milestoneId: 'milestoneId' in updateArgs ? updateArgs.milestoneId : undefined,
        })
      })
    },
    [environment],
  )
  return <BulkIssueMilestonePickerTsq {...props} onMutate={onMutate} />
}

try{ BulkIssueMilestonePicker.displayName ||= 'BulkIssueMilestonePicker' } catch {}